/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { Component, ElementRef, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TextareaModule } from '@openng/optimus-ui/textarea';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ControlValueAccessorConnectorComponent } from '../control-value-accessor.connector';
import { BaseFormControlDirective, BaseFormControlDirectiveInputs } from '../directives/base-form-control.directive';
import {
  TextFormControlDirective,
  TextFormControlDirectiveInputs,
  TextFormControlDirectiveOutputs,
} from '../directives/text-form-control.directive';
import {
  TextareaFormControlDirective,
  TextareaFormControlDirectiveInputs,
} from '../directives/textarea-form-control.directive';
import { FormComponent } from '../form/form.component';

import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
  selector: 'ui-textarea',
  host: { class: 'block mb-4' },
  templateUrl: './textarea.component.html',
  imports: [ReactiveFormsModule, InputWrapperComponent, TextareaModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextareaComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [
    {
      directive: BaseFormControlDirective,
      inputs: BaseFormControlDirectiveInputs,
    },
    {
      directive: TextFormControlDirective,
      inputs: TextFormControlDirectiveInputs,
      outputs: TextFormControlDirectiveOutputs,
    },
    {
      directive: TextareaFormControlDirective,
      inputs: TextareaFormControlDirectiveInputs,
    },
  ],
})
export class TextareaComponent extends ControlValueAccessorConnectorComponent {
  private _form = inject(FormComponent, { optional: true, skipSelf: true });
  private _el = inject(ElementRef);

  get el(): ElementRef {
    return this._el;
  }

  submitted = false;

  base = inject(BaseFormControlDirective);
  text = inject(TextFormControlDirective);
  textarea = inject(TextareaFormControlDirective);

  constructor() {
    const injector = inject(Injector);

    super(injector);

    if (this._form) {
      this._form
        .getSubmitted()
        .pipe(takeUntilDestroyed())
        .subscribe((_) => (this.submitted = _));
    }
  }
}
